import React from "react";
import { DatePicker, Form, Input, Table } from "antd";
import { Link } from "react-router-dom";
import { AddUpdateTruck } from "./popup/AddUpdateTruck";
import { TruckList } from "../../../models/truck";
import {pagination} from "../../../controller/Utils";
import {AnalyticsHeaderLink} from "../AnalyticsHeaderLink";

const { RangePicker } = DatePicker;
const Search = Input.Search;

class AddTruckPage extends React.Component {
  state = {
    visible: false,
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    update: false,
  };
  fetch = (params = {}) => {
    this.setState({ loading: true, params: params });
    TruckList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onRowShowClick = (id) => {
    this.setShowTruckModel(true);
    this.setState({ showTruckModelData: id })
  };
  onRowUpdateClick = (row_id) => {
    this.setState({ row_id });
    this.setCreateEmpVisible(true);
  };
  columns = [
    {
      title: 'View',
      render: (item) => <div className="action-column">
        <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil" /></a>
        <a title="Delete"><i className="fa fa-trash" /></a>
      </div>
    }, {
      title: 'Truck Id',
      dataIndex: 'truck_id',
    }, {
      title: 'Truck Type',
      dataIndex: 'type',
      render: type => type? type.type_name: '-'
    }, {
      title: 'Truck Capability',
      dataIndex: 'jobs',
      render: jobs => jobs.map(item => item.name).join(', '),
    }, {
      title: ' Truck Specifications',
      dataIndex: 'description',
    }, {
      title: 'Truck Ownership',
      dataIndex: 'owner',
      render: owner => owner? owner.name: ""
    }, {
      title: 'Active',
      dataIndex: 'active',
      render: active => active? <span className="completed">Active</span>:<span className="pending">Inactive</span>
    }
  ];
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'date_joined',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ...filters,
    });
  };
  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  setCreateEmpVisible(createEmpShow) {
    this.setState({ createEmpShow });
    if (!createEmpShow)
      this.setState({ row_id: createEmpShow })
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const { pagination, data, loading, selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Analytics</h3>
              </div>
              <div className="col-sm-9 col-12">
                <AnalyticsHeaderLink/>
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker onChange={this.onDateRangeChange} />
                </div>
              </div>
              <div className="col-sm-2 col-12">
                <button className="btn submit-btn xs-hide" type="primary"
                  onClick={() => this.setCreateEmpVisible(true)}>Add Truck
                </button>
              </div>
              <div className="col-sm-3 col-12">
                <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                  style={{ width: 200 }} />
              </div>
              <div className="col-sm-3 col-12 edit-div">
                <span>{pagination.total} Records</span>
                <button className="btn btn-edit">
                  <i className="icon-printer" />
                </button>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-12">
                <div className="listing-table">
                  <Table
                    className="report-table responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                    pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                    dataSource={data} loading={loading} onChange={this.handleTableChange}
                    locale={{ emptyText: 'No Truck Available' }} />
                </div>
              </div>
            </div>
            <AddUpdateTruck row_id={this.state.row_id} visible={this.state.createEmpShow} fetch={() => this.fetch()} setModelVisible={() => this.setCreateEmpVisible(false)} />
          </div>
        </div>
      </div>
    );
  }
}

export const AddTruck = Form.create()(AddTruckPage);


// WEBPACK FOOTER //
// ./src/pages/analytics/add_truck/AddTruck.jsx